import * as React from 'react';

const Rss16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M1 1.75c0-.414.337-.752.751-.732C8.903 1.38 14.634 6.892 15 14.268a.723.723 0 0 1-.732.75c-.415 0-.748-.336-.778-.75-.42-5.964-5.776-11.32-11.739-11.74-.414-.03-.75-.363-.75-.777Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M1.75 6.564c-.413-.036-.75.304-.75.719 0 .414.337.747.75.786 3.376.323 5.875 2.822 6.198 6.199.04.412.372.75.786.75s.755-.338.721-.752c-.353-4.328-3.742-7.36-7.705-7.702m-.251 5.491c-.273-.046-.499.183-.499.46v2.002a.5.5 0 0 0 .501.5h2.003c.276 0 .505-.225.459-.498a3.01 3.01 0 0 0-2.464-2.464"
  }
));
Rss16.Size = 16;
Rss16.Title = "Rss";

export { Rss16 as default };
